import { GET_DEVICE_TYPES_SUCCESS } from './types';
import { setProgress } from './progressActions';
import { getDeviceTypes } from 'services/devices.service';
import { sendMessage } from './errorHandlingActions';

export interface DeviceTypesSuccessAction {
	type: typeof GET_DEVICE_TYPES_SUCCESS;
	payload: Array<any>;
}

export const getDeviceTypeData = (payload: Array<any>): DeviceTypesSuccessAction => {
	return {
		type: GET_DEVICE_TYPES_SUCCESS,
		payload: payload,
	};
};

export const deviceTypesList = ():any => async (dispatch: any) => {
	try {
		dispatch(setProgress(true));
		const deviceType = await getDeviceTypes();
		dispatch(getDeviceTypeData(deviceType));
		dispatch(setProgress(false));
	} catch (error:any) {
		dispatch(sendMessage(error, 'error'));
		dispatch(setProgress(false));
	}
};
